import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const updateTenderItem = createAsyncThunk(
    "updateTenderItem",
    async ({ itemId, payload }, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.put(`tms/tenders/items/${itemId}`, payload);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const checkItemBids = createAsyncThunk(
    "checkItemBids",
    async (itemId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get(`tms/tender-items/${itemId}/bids`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const rejectItemBids = createAsyncThunk(
    "rejectItemBids",
    async (itemId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.patch(`tms/tender-items/${itemId}/reject-bids`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const TenderItemUpdateSlice = createSlice({
    name: "TenderItemUpdateSlice",
    initialState: {
        isLoading: false,
        isActionLoading: false,
        data: null,
        error: null,
    },
    reducers: {
        resetTenderItemUpdate: (state) => {
            state.isLoading = false;
            state.isActionLoading = false;
            state.data = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateTenderItem.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateTenderItem.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(updateTenderItem.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(rejectItemBids.pending, (state) => {
                state.isActionLoading = true;
            })
            .addCase(rejectItemBids.fulfilled, (state) => {
                state.isActionLoading = false;
            })
            .addCase(rejectItemBids.rejected, (state) => {
                state.isActionLoading = false;
            });
    },
});

export const { resetTenderItemUpdate } = TenderItemUpdateSlice.actions;
export default TenderItemUpdateSlice.reducer;
